module.exports = __webpack_public_path__ + "co.a742e2c15b40bc315ceb.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/co.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/co.svg
// module chunks = styles